import React, { useEffect, useState } from "react";
import NoSearch from "./NoSearch";
import PlaylistCard from "pages/musicPage/playlist/PlaylistCard";

function SearchPlaylistSection({ data, user }: any) {
  const playlists = data?.public_playlists || [];

  return (
    <div>
      {/* top section */}
      <div className="mb-8 w-[98%] ml-6 mt-8 max-sm:w-full max-sm:mx-0">
        <div>
          <h1 className="text-xl font-semibold text-white lg:text-xl md:text-xl">
            {/* search podcast */}
            Playlist
          </h1>
        </div>
      </div>
      {/* card section */}
      {playlists.length === 0 && playlists ? (
        <NoSearch text="Playlist" />
      ) : (
        <div>
          <div className="mt-4 mb-5 w-[95%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 max-sm:mx-auto max-sm:w-full max-sm:gap-4">
            {playlists?.length > 0 &&
              playlists?.map((playlist: any, i: any) => (
                <div key={i}>
                  <PlaylistCard playlist={playlist} searchPage={true} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchPlaylistSection;
